import { DocumentSignatureStatus } from '@bulthaup/api/db';
import { Badge } from '@mantine/core';
import { IconCheck, IconClock, IconX } from '@tabler/icons-react';

import { label } from '../../../../../utils/label';

interface SignatureRequestStatusProps {
  status: DocumentSignatureStatus;
}

export function SignatureRequestStatusBadge({
  status,
}: SignatureRequestStatusProps) {
  const getStatusConfig = () => {
    switch (status) {
      case DocumentSignatureStatus.DONE:
        return {
          color: 'green',
          icon: <IconCheck size={14} />,
          label: label(DocumentSignatureStatus.DONE),
        };
      case DocumentSignatureStatus.ONGOING:
        return {
          color: 'yellow',
          icon: <IconClock size={14} />,
          label: label(DocumentSignatureStatus.ONGOING),
        };
      case DocumentSignatureStatus.DECLINED:
        return {
          color: 'red',
          icon: <IconX size={14} />,
          label: label(DocumentSignatureStatus.DECLINED),
        };
      case DocumentSignatureStatus.REJECTED:
        return {
          color: 'red',
          icon: <IconX size={14} />,
          label: label(DocumentSignatureStatus.REJECTED),
        };
      case DocumentSignatureStatus.CANCELED:
        return {
          color: 'red',
          icon: <IconX size={14} />,
          label: label(DocumentSignatureStatus.CANCELED),
        };
      case DocumentSignatureStatus.EXPIRED:
        return {
          color: 'red',
          icon: <IconX size={14} />,
          label: label(DocumentSignatureStatus.EXPIRED),
        };
      case DocumentSignatureStatus.DRAFT:
        return {
          color: 'gray',
          icon: <IconClock size={14} />,
          label: label(DocumentSignatureStatus.DRAFT),
        };
      default:
        return {
          color: 'gray',
          icon: <IconClock size={14} />,
          label: label(DocumentSignatureStatus.DRAFT),
        };
    }
  };

  const statusConfig = getStatusConfig();

  return (
    <Badge
      color={statusConfig.color}
      leftSection={statusConfig.icon}
      variant="outline"
      size="lg"
    >
      {statusConfig.label}
    </Badge>
  );
}
